import autoRoutes from 'vue-auto-routing'
import { Base404 } from '@technologyadvice/relay-frontend'
import AppLayout from '@/layouts/default.vue'

/* Enable this again if I can figure out why the linter doesn't like it
const RouterLayout = createRouterLayout(function (layout) {
    return import('@layouts/' + layout + '.vue')
})
*/

const routes = [
    {
        path: '/',
        component: AppLayout, // RouterLayout,
        meta: { requiresAuth: true },
        children: [
            ...autoRoutes,
            {
                path: '/404',
                alias: '*',
                name: '404',
                component: Base404,
                meta: {
                    title: '404: Page Not Found',
                },
            },
        ],
    },
]

export default routes
